// JS
import React from 'react';

// COMPONENTS
import Button from '../Button';

// COMPONENT
const BrandFocusHero = ({ item, productPosition, gaBlockName }) => {
  return (
    <div
      className="relative"
      data-name={item.block_title}
      data-creative={gaBlockName}
      data-id={item.contentguid}
      data-position={'banner-slot-' + productPosition}
      data-type="banner"
    >
      <a
        href={item.url}
        alt={item.link_label}
        className="group flex items-end w-full aspect-[9/8] md:aspect-[9/3] bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${item.icon})`
        }}
        data-name={item.block_title}
        data-creative={gaBlockName}
        data-id={item.contentguid}
        data-position={'button-slot-' + productPosition}
        data-type="banner-button"
      >
        <div className="after:absolute after:inset-0 after:z-0 after:w-full after:h-full after:bg-gradient-to-t after:from-black/40"></div>
        <div className="flex w-full flex-row justify-between items-center pl-8 absolute left-0 right-0 bottom-7 md:px-14 md:bottom-10">
          <div className="text-lg text-white uppercase lg:text-xl">
            <h2 className="font-bold">
              {item.block_title}
              <p className="font-base text-lg lg:!text-xl">
                {item.block_sub_title}
              </p>
            </h2>
          </div>
          <Button
            buttonColour="white"
            buttonGroup={true}
            buttonLink={item.url}
            buttonLinkText={item.link_label}
            buttonAdditionalClasses={{
              classes: 'hidden md:block'
            }}
          />
        </div>
      </a>
    </div>
  );
};

export default BrandFocusHero;
